import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en';
import React from 'react';
import { Provider } from 'react-redux';

import MuiXLicense from '../licensing/MuiXLicense';
import redux from './redux';
import translations from './translations';
import CustomerServiceManager from './views/customer-service-manager';
import GroupSwitcher from './views/group-switcher';

translations.init();

type CustomerGroupSelectorProps = {
  customerServiceUrl: string;
};

const CustomerGroupSelector = (props: CustomerGroupSelectorProps) => {
  return (
    <>
      <Provider store={redux.store}>
        <LocalizationProvider adapterLocale="en" dateAdapter={AdapterDayjs}>
          <>
            <GroupSwitcher />
            <CustomerServiceManager {...props} />
          </>
        </LocalizationProvider>
      </Provider>
      <MuiXLicense />
    </>
  );
};

export default CustomerGroupSelector;
